import { render, staticRenderFns } from "./TableEvaluacion.vue?vue&type=template&id=6138288b"
import script from "./TableEvaluacion.vue?vue&type=script&lang=js"
export * from "./TableEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./TableEvaluacion.vue?vue&type=style&index=0&id=6138288b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports